import React, { ReactElement } from 'react';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import InputMask from '../InputMask/InputMask';

const FormCustomMaskedInput = (props: any): ReactElement => {
  const { mask, regxvalidator, inputRef } = props;
  const formConfig = useGetFormConfig(props);
  const { disabled, rules, onChange, placeholder, key, allowClear, required, onFocus, onBlur } = formConfig;
  if (regxvalidator) {
    rules.push({
      pattern: new RegExp(regxvalidator),
      message: `Please enter in desired format`,
    });
  }

  return <FormItem formConfig={formConfig} >
    <InputMask {...props}
      data-testid={key}
      allowClear={allowClear}
      onChange={(event: any): any => onChange(event)}
      mask={mask}
      placeholder={placeholder}
      disabled={disabled}
      maskChar=""
      required={required}
      onFocus={(event: React.FocusEvent<HTMLInputElement>): void => {
        onFocus?.(event);
      }}
      onBlur={onBlur}
      ref={inputRef}/>
  </FormItem>;
};

export default FormCustomMaskedInput;
